var React = require('react');

function PrinterInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeWidth":"1.3","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M5.8 9.4V1h14.4v8.4M5.8 20.2H3.4A2.4 2.4 0 011 17.8v-6a2.4 2.4 0 012.4-2.4h19.2a2.4 2.4 0 012.4 2.4v6a2.4 2.4 0 01-2.4 2.4h-2.4","key":0}),React.createElement("path",{"d":"M5.8 15.4h14.4V25H5.8z","key":1})]));
}

PrinterInline.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = PrinterInline;

PrinterInline.default = PrinterInline;
